module.exports = __webpack_public_path__ + "static/media/NotasFiscais11.3ad09016.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancNotasFiscais/NotasFiscais11.png
// module id = 2142
// module chunks = 0